export const Red = {
  primary: '#EE3E5C',
  secondary: '#FEF4F6',
  tertiary: '#E7EAEC',
};
